//i18nHelpPath
export default {
	Login: 'kb/dang-nhap-mtax/',
	ForgotPassword: 'kb/quen-mat-khau-dang-nhap/',
	Agreement: 'kb/xac-nhan-thoa-thuan-su-dung-dich-vu/',
	ServiceRegistration: 'kb/tra-cuu/#4-theo-doi-ket-qua-dang-ky-dich-vu',
	TaxDecRegistrationStep1:
		'kb/dang-ky-dich-vu-khai-thue/#1-dang-ky-chung-thu-so',
	TaxDecRegistrationStep2:
		'kb/dang-ky-dich-vu-khai-thue/#2-dang-ky-thong-tin-lien-he',
	TaxPayRegistrationStep3:
		'kb/dang-ky-dich-vu-khai-thue/#3-ky-so-len-to-khai',
	TaxPayRegistrationStep1:
		'kb/dang-ky-dich-vu-nop-thue/#1-dang-ky-chung-thu-so',
	TaxPayRegistrationStep2:
		'kb/dang-ky-dich-vu-nop-thue/#2-dang-ky-tai-khoan-ngan-hang',
	TaxPayRegistrationStep3:
		'kb/dang-ky-dich-vu-nop-thue/#3-dang-ky-thong-tin-lien-he',
	TaxPayRegistrationStep4: 'kb/dang-ky-dich-vu-nop-thue/#4-ky-so-len-to-khai',
	TaxRegistrationStep1:
		'kb/dang-ky-dich-vu-khai-thue-va-nop-thue/#1-dang-ky-chung-thu-so',
	TaxRegistrationStep2:
		'kb/dang-ky-dich-vu-khai-thue-va-nop-thue/#2-dang-ky-tai-khoan-ngan-hang',
	TaxRegistrationStep3:
		'kb/dang-ky-dich-vu-khai-thue-va-nop-thue/#3-dang-ky-thong-tin-lien-he',
	TaxRegistrationStep4:
		'kb/dang-ky-dich-vu-khai-thue-va-nop-thue/#4-ky-so-len-to-khai',
	TaxChangeRegistration: 'kb/thay-doi-bo-sung-thong-tin-giao-dich-dien-tu/',
	TaxChangeCARegistration: 'kb/dang-ky-thay-doi-thong-tin-chung-thu-so/',
	TaxChangeContactInfoRegistration: 'kb/dang-ky-thong-tin-lien-he/',
	TaxChangeAllInfoRegistration:
		'kb/thay-doi-bo-sung-thong-tin-giao-dich-dien-tu/',
	TaxAddBankRegistration: 'kb/dang-ky-bo-sung-ngan-hang/',
	TaxStopBankRegistration: 'kb/dang-ky-ngung-ngan-hang/',
	TaxDecStopServiceRegistration: 'kb/dang-ky-ngung-dich-vu-khai-thue/',
	TaxPayStopServiceRegistration: 'kb/dang-ky-ngung-dich-vu-nop-thue/',
	TaxReturnRegistration: 'kb/dang-ky-to-khai-thue-nop-qua-mang/',
	TaxReturnRegistrationHaunt: 'kb/dang-ky-co-quan-thue-vang-lai/',
	TaxReturnDeRegistration: 'kb/dang-ky-ngung-nop-to-khai/',
	TaxReturnSubmission: 'kb/nop-to-khai-thue/#2-nop-to-khai',
	TaxPayerInfo: 'kb/cap-nhat-thong-tin-nguoi-nop-thue/',
	UserManagement: 'kb/6-phan-quyen-su-dung/',
	EmailNotification: 'kb/cap-nhat-email-thong-bao/',
	CancelOrder: 'kb/toi-muon-huy-don-hang-da-dat-tren-website/',
	AcceptPayment:
		'kb/xac-nhan-thanh-toan-don-hang-dat-mua-phan-mem-misa-mtax/',
	TaxPaymentSubmission: 'kb/nop-thue/#buoc-1-lap-giay-nop-tien',
	TaxPaymentSubmission2:
		'kb/nop-thay-tien-thue/#buoc-1-lap-giay-nop-tien-thay',
	TaxPaymentSubmissionPreview: 'kb/nop-thue/#buoc-2-ky-va-gui-giay-nop-tien',
	TaxPaymentSubmission2Preview:
		'kb/nop-thay-tien-thue/#buoc-2-ky-va-gui-giay-nop-tien-thay',
	TaxReturnSubmissionIsPaidList: 'kb/quan-ly-tinh-hinh-nop-thue/',
	MustPayTaxAmountReport: 'kb/quan-ly-tinh-hinh-nop-thue/',
	NPS: 'kb/bo-sung-man-hinh-danh-gia-chat-luong-dich-vu/',
	SuggestTaxReturnRegister:
		'kb/goi-y-to-khai-dang-ky-khi-dang-ky-to-khai-nop-qua-mang/'
};
